export default __webpack_public_path__ + "static/media/BackgroundLandingPageMobile.93042507.jpg";